import state from './moduleTagManagementState.js'
import mutations from './moduleTagManagementMutations.js'
import actions from './moduleTagManagementActions.js'
import getters from './moduleTagManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters

}

